"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createTheme = _interopRequireDefault(require("../helpers/createTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = (0, _createTheme["default"])({
  gray: '#808080',
  success: '#49bb49',
  warning: '#ff9540',
  error: '#f96464',
  info: '#40a3f2',
  primary: '#0084ee',
  secondary: '#009000'
});

exports["default"] = _default;